import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "@/components/table/Auth";
import imgSave from "@/components/table/saveImg";
import dataDefault from './data';
import { columns, compute, fillData } from "./compute";
import request from "@/method/axios";
import _ from 'lodash';

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().format('YYYY-MM'),
        table1: [],
        table2: [],
        table3: [],
        loading: true,
        loadingSave: false,
        print: false,
        data4_1: [],
        key: "_4_2_2_new"
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, key) => {
        data = compute(data);
        this.setState({ [key]: data, loading: false, });
    }
    onChange = (name, value, i, key = "talbe1") => {
        let data = this.state[key];
        data[i][name] = value;
        this.computeNum(data, key);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true, table1: [], table2: [], table3: [] });
            let table1 = JSON.parse(JSON.stringify(dataDefault));
            let table2 = JSON.parse(JSON.stringify(dataDefault));
            let table3 = JSON.parse(JSON.stringify(dataDefault));
            let month = moment(date).format('M');
            const year = moment(date).format('YYYY');
            const nextYear = moment(date).add(3, 'month').format('YYYY');
            const needData = [{
                name: "budget",
                key: "_4new_4_3_1_budget",
                year
            }];
            if (month < 10) {
                needData.push({
                    name: "fone",
                    key: "_4new_4_3_1_forecast",
                    year: moment(date).format('YYYY'),
                    month: moment(date).format('M'),
                }, {
                    name: "ftwo",
                    key: "_4new_4_3_1_forecast",
                    year: moment(date).format('YYYY'),
                    month: moment(date).format('M'),
                }, {
                    name: "fthree",
                    key: "_4new_4_3_1_forecast",
                    year: moment(date).format('YYYY'),
                    month: moment(date).format('M'),
                })
            }
            if (month == 10) {
                needData.push({
                    name: "fone",
                    key: "_4new_4_3_1_forecast",
                    year,
                    month: 10,
                }, {
                    name: "ftwo",
                    key: "_4new_4_3_1_forecast",
                    year,
                    month: 10,
                }, {
                    name: "fthree",
                    key: "_4_2_1_new",
                    year: nextYear,
                    month: 1,
                })
            }
            if (month == 11) {
                needData.push({
                    name: "fone",
                    key: "_4new_4_3_1_forecast",
                    year,
                    month: 11,
                }, {
                    name: "ftwo",
                    key: "_4_2_1_new",
                    year: nextYear,
                    month: 1,
                }, {
                    name: "fthree",
                    key: "_4new_4_3_1_forecast",
                    year: nextYear,
                    month: 1,
                })
            }
            if (month == 12) {
                needData.push({
                    name: "fone",
                    key: "_4_2_1_new",
                    year: nextYear,
                    month: 1,
                }, {
                    name: "ftwo",
                    key: "_4new_4_3_1_forecast",
                    year: nextYear,
                    month: 1,
                }, {
                    name: "fthree",
                    key: "_4new_4_3_1_forecast",
                    year: nextYear,
                    month: 1,
                })
            }
            if (month >= 10) {
                needData.push({
                    name: "budgetNext",
                    key: "_4new_4_3_1_budget",
                    year: nextYear
                });
            }
            const res = await request.post('/api/data', {
                list: [{
                    name: "table1",
                    key: this.state.key, year, month
                }, {
                    name: "table2",
                    key: "_4_2_2_new_2", year, month
                }, {
                    name: "table3",
                    key: "_4_2_2_new_3", year, month
                }, ...needData]
            });
            if (res.data.table1 && res.data.table1.length) table1 = res.data.table1;
            if (res.data.table2 && res.data.table2.length) table2 = res.data.table2;
            if (res.data.table3 && res.data.table3.length) table3 = res.data.table3;
            const fill = fillData({ table1, table2, table3 }, { ...res.data, date, year, month });
            console.log(fill);
            this.setState({
                table1: fill.table1, table2: fill.table2, table3: fill.table3, loading: false
            })
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {
        try {
            let { date, key, table1, table2, table3 } = this.state;
            if (!date) return message.error('请选择年份月份');

            this.setState({ loadingSave: true });
            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = table1.map((x, i) => {
                const res = ({ ...x, year, sort: i, month })
                return res;
            });
            const postData = {
                data,
                year,
                key,
                month
            };
            const x = await Promise.all(
                [
                    request.post(`/api/save`, postData),
                    request.post(`/api/save`, {
                        data: table2.map((x, i) => {
                            const res = ({ ...x, year, sort: i, month })
                            return res;
                        }),
                        year,
                        key: "_4_2_2_new_2",
                        month
                    }),
                    request.post(`/api/save`, {
                        data: table3.map((x, i) => {
                            const res = ({ ...x, year, sort: i, month })
                            return res;
                        }),
                        year,
                        key: '_4_2_2_new_3',
                        month
                    })
                ]
            );

            this.setState({ loadingSave: false });
            if (x[0].code == 200) {
                message.success("保存成功！");
                if (!data[0].id) this.getData(this.state.date);
            }
        } catch (err) {
            this.setState({ loadingSave: false });
            console.error(err);
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '4.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = (id) => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 4.2.2 未来3个月销售策略和行动计划`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById(id).innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { table1, table2, table3, date, print, loading, key } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4"   >
                    <Row>4.2.2 未来3个月销售策略和行动计划</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            value={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str);
                            }}
                        />
                    </Row>
                    <Table
                        columns={columns((name, value, i) => this.onChange(name, value, i, 'table1'), date, print, 'table1')}
                        dataSource={table1}
                        size="middle"
                        id="table1"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                    {!print && <Button
                        type="primary"
                        style={{ marginTop: 20, marginLeft: "calc(100% - 200px)" }}
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel('table1');
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>}
                    <Table
                        columns={columns((name, value, i) => this.onChange(name, value, i, 'table2'), date, print, 'table2')}
                        dataSource={table2}
                        size="middle"
                        id="table2"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                    {!print && <Button
                        type="primary"
                        style={{ marginTop: 20, marginLeft: "calc(100% - 200px)" }}
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel('table2');
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>}
                    <Table
                        columns={columns((name, value, i) => this.onChange(name, value, i, 'table3'), date, print, 'table3')}
                        dataSource={table3}
                        size="middle"
                        id="table3"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                    {!print && <Button
                        type="primary"
                        style={{ marginTop: 20, marginLeft: "calc(100% - 200px)" }}
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel('table3');
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>}
                </Row>
                <Row className="table-footer-btn" style={{ marginTop: 10 }}>

                    <Auth loading={this.state.loading} auth="edit_4_2_2_new">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.2/index.js